import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import * as ConfigurationActions from "../../store/configurationService/actions";
import { useTranslation } from "react-i18next";
import LogoContainer from "../common/LogoContainer";
import ApiFailedError from "../MobileAttackView/ApiFailedError";
import { useHistory } from "react-router-dom";
import CustomError from "./CustomError";

const RegistrationError = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const query = new URLSearchParams(history.location.search);
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const renderSiteInIFrame: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.renderInIframe
            ? state.configurationState.configuration.partnerConfig.renderInIframe
            : false
    );
    const originSiteUrl = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.originSiteUrl
            ? state.configurationState.configuration.partnerConfig.originSiteUrl
            : ""
    );
    const showLogoOnRegistrationScreens: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.registration
            ? state.configurationState.configuration.partnerConfig.registration.includePartnerLogo
            : false
    );
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const ssoError = query.get("type") === "SSO_ERROR";
    const showCustomErrorPage = useSelector(
        (state: ApplicationState) =>
            (state.configurationState &&
                state.configurationState.configuration &&
                state.configurationState.configuration.partnerConfig &&
                state.configurationState.configuration.partnerConfig.ssoOptions &&
                state.configurationState.configuration.partnerConfig.ssoOptions.showCustomErrorPage) ||
            false
    );

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
        if (ssoError) {
            history.push("/system-error");
        }
    }, [routeLoading, ssoError]);

    const isOneTrustPartner = useSelector((state: ApplicationState) => {
        const partnerId = state.configurationState?.configuration?.partnerConfig?.partnerId;
        return partnerId != null && [2649, 1557].includes(partnerId);
    });

    useEffect(() => {
        if (isOneTrustPartner) {
            var cookiePrefIcon = document.getElementById('onetrust-consent-sdk');
            if (cookiePrefIcon != null) {
                cookiePrefIcon.remove();
            }
            var cdnScript = document.createElement("script");
            cdnScript.setAttribute("src", "https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js");
            cdnScript.setAttribute("type", "text/javascript");
            cdnScript.setAttribute("charSet", "UTF-8");
            cdnScript.setAttribute("data-domain-script", "0191c174-bd6a-7b60-a80c-64c37644ffc1");
            document.getElementsByTagName("body")[0].appendChild(cdnScript);
            var script = document.createElement("script");
            script.setAttribute("type", "text/javascript");
            document.getElementsByTagName("body")[0].appendChild(script);
            var optanonWrapper = "function OptanonWrapper() { }";
            script.innerHTML = optanonWrapper;
            return () => {
                document.body.removeChild(cdnScript);
                document.body.removeChild(script);
            }
        }
    }, []);

    return (
        <div className="row margin-vertical-xl">
            {
                showCustomErrorPage ? <CustomError /> :
                    <div className={`box ${renderSiteInIFrame ? "col-xs-12" : ""} box-has-shadow box-lg`}>
                        {showLogoOnRegistrationScreens && (
                            <div className="col-xs-0 col-sm-12 row flex-end">
                                <LogoContainer internalPage={false} className="hide-mobile" showLogoOnRegistrationScreens={showLogoOnRegistrationScreens} />
                            </div>
                        )}

                        {showLogoOnRegistrationScreens && (
                            <div className="col-xs-12 col-sm-0 hide-sm-up text-align-center">
                                <LogoContainer internalPage={false} showLogoOnRegistrationScreens={showLogoOnRegistrationScreens} />
                            </div>
                        )}

                        {renderSiteInIFrame ? (
                            <ApiFailedError fromRegistration={true} />
                        ) : (
                            <div className="box-content">
                                <p className="margin-bottom-xs">{tLang("registration.registerErrorWidget.message")}</p>

                                <h3 className="content-title">{tLang("registration.registerErrorWidget.q1")}</h3>
                                <p className="margin-bottom-xs">{tLang("registration.registerErrorWidget.text1")}</p>

                                <h3 className="content-title">{tLang("registration.registerErrorWidget.q2")}</h3>
                                <p className="margin-bottom-xs">{tLang("registration.registerErrorWidget.text2")}</p>

                                <h3 className="content-title">{tLang("registration.registerErrorWidget.q3")}</h3>
                                <p className="margin-bottom-xs">
                                        <a href={isPartnerIdIsTransunion ? 'https://www.identityforce.com/':`https://${originSiteUrl}`} className="default_link">
                                        {tLang("registration.registerErrorWidget.clickHereLinkText")}
                                    </a>
                                    {tLang("registration.registerErrorWidget.text3")}
                                </p>
                            </div>
                        )}
                    </div>
            }
        </div>
    );
};

export default RegistrationError;
